var normalSkinnedVS = `
vec3 getNormal() {
	dNormalMatrix = mat3(dModelMatrix[0].xyz, dModelMatrix[1].xyz, dModelMatrix[2].xyz);
	return normalize(dNormalMatrix * vertex_normal);
}
`;

export { normalSkinnedVS as default };
